module.exports = __webpack_public_path__ + "static/media/shopee-blog.14d3aa48.svg";